// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cs57A","fullView":"styles_fullView__2Plrh"};